import {
    ComboboxOption as HeadlessUIComboboxOption,
    type ComboboxOptionProps,
} from "@headlessui/react";
import classnames from "classnames";
import type { ElementType } from "react";
import * as React from "react";

import assets from "../../common/assets";
import styles from "./Combobox.module.scss";

const ComboboxOption = <TValue, TTag extends ElementType = "div">(
    props: React.PropsWithChildren<ComboboxOptionProps<TTag, TValue>>
) => {
    return (
        <HeadlessUIComboboxOption
            as="div"
            className={({ focus }) =>
                `${styles.Option} ${focus ? styles.OptionActive : ""}`
            }
            value={props.value}>
            {({ selected }) => (
                <>
                    {selected && assets.checkmarkTransparent}
                    <div
                        className={classnames(
                            selected
                                ? styles.OptionSelected
                                : styles.OptionUnselected
                        )}>
                        {props.children}
                    </div>
                </>
            )}
        </HeadlessUIComboboxOption>
    );
};

export default ComboboxOption;
